import styles from './ErrorText.module.css';

interface ErrorTextProps extends React.HTMLAttributes<HTMLDivElement> {}

const ErrorText = ({ className, ...props }: ErrorTextProps): React.JSX.Element => (
    <div className={`${styles.errorText}${className ? ` ${className}` : ''}`} {...props} />
);

export { ErrorText };
